export function getRegistrationSourceUrl(): string {
  if (typeof document === "undefined") {
    return "";
  }

  return (document.referrer ?? "").trim();
}
